enum ExerciseListResolutionMode {
    Exam = "exam",
    Study = "study",
    Feedback = "feedback"
}

export default ExerciseListResolutionMode;
